import { type AnyAction } from 'redux';
import { errors } from 'redux-rest-reducer';

import { ACTIONS as authActions } from '@~/actions/auth';
import { ACTIONS as logoutActions } from '@~/actions/logout';
import { setUser } from '@~/modules/sentry';
import {
  getUserIdFromCookie,
  getStudentServiceIdFromCookie,
  getActiveUserTypeFromCookie,
  getLoggedInAsFromCookie,
} from '@~/utils/auth';

const userId = getUserIdFromCookie() || undefined;
const studentServiceId = getStudentServiceIdFromCookie() || undefined;
const activeUserType = getActiveUserTypeFromCookie() || undefined;
const loggedInAs = getLoggedInAsFromCookie() || undefined;
const loggedIn = !!userId;

export enum EUserRole {
  STUDENT = 'student',
  PARENT = 'parent',
}

type AuthState = {
  loggedIn: boolean;
  userId?: string;
  studentServiceId?: string;
  activeUserType?: EUserRole; // Determines root navigation after login based on active user type
  loggedInAs?: EUserRole; // The original authentication method (how the user actually logged in)
  redirectTo?: string | null; // URL to navigate to after login, if provided from react-native app
};

const initialState: AuthState = {
  loggedIn,
  userId,
  studentServiceId,
  activeUserType,
  loggedInAs,
  redirectTo: null,
};

export default function defaultExport(
  state = initialState,
  { type, payload }: AnyAction,
): AuthState {
  if (type === authActions.LOGIN_SUCCESS) {
    setUser(payload.user_id);

    return {
      ...state,
      loggedIn: true,
      userId: payload.user_id,
      studentServiceId: payload.student_service_id,
      loggedInAs: payload.loggedInAs || undefined,
    };
  }

  if (type === authActions.SET_ACTIVE_USER_TYPE) {
    return {
      ...state,
      activeUserType: payload.activeUserType || null,
    };
  }

  if (type === authActions.SET_REDIRECT_TO) {
    return {
      ...state,
      redirectTo: payload.redirectTo || null,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    setUser(null);

    return {
      loggedIn: false,
      studentServiceId: undefined,
      userId: undefined,
      activeUserType: undefined,
      loggedInAs: undefined,
      redirectTo: null,
    };
  }

  return state;
}
